<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
          >
          <Divider orientation="left">{{ langMap.configManagement[lang] }}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="10"
            :lg="10"
          >
          <Form :label-width="100">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.name[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="name "
                  :placeholder="langMap.name[lang]"
                />
              </FormItem>
              <FormItem
                :label="langMap.uniqueIdentifier[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="key"
                  :placeholder="langMap.pleaseInputUniqueId[lang]"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{ langMap.search[lang] }}</Button>
              <Button
                type="primary"
                style="margin-left:20px;"
                @click="addShow"
              >{{ langMap.add[lang] }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="col"
        :data="list"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="list.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>

    <Modal
      :mask-closable="false"
      :title="langMap.configInfo[lang]"
      v-model="addModal"
      width="700"
    >
      <Form
        ref="add"
        :model="add"
        :rules="addRules"
        :label-width="80"
      >
        <FormItem
          :label="langMap.name[lang]"
          prop="configName"
        >
          <Input
            type="text"
            v-model="add.configName"
            :placeholder="langMap.name[lang]"
          />
        </FormItem>
        <FormItem
          :label="langMap.uniqueIdentifier[lang]"
          prop="configKey"
        >
          <Input
            type="text"
            v-model="add.configKey"
            :placeholder="langMap.pleaseInputUniqueId[lang]"
          />
        </FormItem>

        <FormItem
          :label="langMap.value[lang]"
          prop="configValue"
        >
          <Input
            type="textarea"
            v-model="add.configValue"
            :placeholder="langMap.pleaseInputValue[lang] + langMap.configValueJsonPlaceholderSuffix[lang]"
            :autosize="{ minRows: 4, maxRows: 12 }"
            show-word-limit
            :maxlength="5000"
            style="font-family: 'Consolas', 'Monaco', 'Courier New', monospace;"
          />
          <div class="config-value-tips">
            <div class="tips-content">
              <Icon type="ios-information-circle" />
              <span>{{ langMap.configValueJsonTip[lang] }}</span>
            </div>
            <Button
              type="text"
              size="small"
              @click="formatJson"
              style="color: #17a2b8; padding: 0;"
            >
              <Icon type="ios-code" />
              {{ langMap.formatJsonButton[lang] }}
            </Button>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="addHide()"
          style="margin-left: 8px"
        >{{ langMap.cancel[lang] }}</Button>
        <Button
          @click="saveInfo"
          type="primary"
        >{{ langMap.save[lang] }}</Button>
      </div>
    </Modal>
  </div>

</template>

<script>
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      addModal: false,
      height: document.documentElement.clientHeight - 300,
      list: [],
      name: "",
      key: "",
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      timer: null,
      add: {
        id: "",
        configName: "",
        configKey: "",
        configValue: ""
      },
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    col(){
      return [
        {
          title: "#",
          key: "index",
          width: 60,
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.name[this.lang],
          minWidth: 120,
          key: "configName"
        },
        {
          title: langMap.uniqueIdentifier[this.lang],
          minWidth: 120,
          key: "configKey"
        },
        {
          title: langMap.value[this.lang],
          minWidth: 150,
          key: "configValue",
          render: (h, params) => {
            return h('div', {
              style: {
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                '-webkit-line-clamp': '3',
                '-webkit-box-orient': 'vertical',
                wordBreak: 'break-all'
              },
              attrs: {
                title: params.row.configValue
              }
            }, params.row.configValue)
          }
        },
        {
          title: langMap.creator[this.lang],
          width: 150,
          key: "createName"
        },
        {
          title: langMap.createTime[this.lang],
          width: 150,
          key: "createTime"
        },
        {
          title: langMap.operation[this.lang],
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.editShow(params.row);
                    }
                  }
                },
                langMap.edit[this.lang]
              ),
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              }),
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.deleteMenuConfirm[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "system-server/config/delete?id=" + params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            ]);
          }
        }
      ]
    },
    addRules() {
      return {
        configName: [{ required: true, message: langMap.pleaseInputName[this.lang] }],
        configKey: [{ required: true, message: langMap.pleaseInputUniqueId[this.lang] }],
        configValue: [{ required: true, message: langMap.pleaseInputValue[this.lang] }]
      }
    }
  },
  methods: {
    //获取产品
    getList() {
      this.tableLoading = true;
      api
        .getData(
          "system-server/config/page?index=" +
            this.index +
            "&name=" +
            this.name +
            "&key=" +
            this.key,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.list = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    editShow(data) {
      (this.add = { ...data }), this.$refs.add.resetFields();
      this.addModal = true;
    },
    addShow() {
      (this.add = {
        id: "",
        configName: "",
        configKey: "",
        configValue: ""
      }),
        this.$refs.add.resetFields();
      this.addModal = true;
    },
    addHide() {
      this.$refs.add.resetFields();
      this.addModal = false;
    },
    // 验证JSON格式
    validateJsonFormat(value) {
      if (!value || value.trim() === '') {
        return true; // 空值允许
      }

      // 检查是否可能是JSON格式（以{或[开头）
      const trimmedValue = value.trim();
      if (trimmedValue.startsWith('{') || trimmedValue.startsWith('[')) {
        try {
          JSON.parse(trimmedValue);
          return true;
        } catch (e) {
          return false;
        }
      }

      return true; // 非JSON格式的普通文本也允许
    },
    // 格式化JSON
    formatJson() {
      const value = this.add.configValue;
      if (!value || value.trim() === '') {
        this.$Notice.warning({
          title: langMap.tip[this.lang],
          desc: langMap.configValueInputFirst[this.lang]
        });
        return;
      }

      const trimmedValue = value.trim();
      if (trimmedValue.startsWith('{') || trimmedValue.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmedValue);
          this.add.configValue = JSON.stringify(parsed, null, 2);
          this.$Notice.success({
            title: langMap.tip[this.lang],
            desc: langMap.configJsonFormatSuccess[this.lang]
          });
        } catch (e) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: langMap.configJsonFormatInvalid[this.lang]
          });
        }
      } else {
        this.$Notice.info({
          title: langMap.tip[this.lang],
          desc: langMap.configContentNotJson[this.lang]
        });
      }
    },
    saveInfo() {
      this.$refs.add.validate(valid => {
        if (valid) {
          // 验证JSON格式
          if (!this.validateJsonFormat(this.add.configValue)) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: langMap.configValueJsonInvalid[this.lang]
            });
            return;
          }

          api
            .postData("system-server/config/save", this.add, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.tip[this.lang],
                  desc: langMap.saveSuccess[this.lang]
                });
                this.addHide();
                this.getList();
              }
              this.$Spin.hide();
            });
        }
      });
    }
  },
  created() {
    this.getList();
  },
  destroyed: function() {}
};
</script>

<style scoped>
.config-value-tips {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  color: #6c757d;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.config-value-tips .tips-content {
  display: flex;
  align-items: center;
}

.config-value-tips .tips-content .ivu-icon {
  margin-right: 6px;
  color: #17a2b8;
}

/* 增强文本域的样式 */
.ivu-input[type="textarea"] {
  resize: vertical;
  line-height: 1.5;
}

/* 字符计数器样式优化 */
.ivu-input-word-count {
  color: #999;
  font-size: 11px;
}
</style>
